import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL, AUTH_PREFIX_PATH } from 'configs/AppConfig';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { signOutSuccess } from 'store/slices/authSlice';
import store from 'store';
import { notification } from 'antd';

const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = localStorage.getItem(AUTH_TOKEN);
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

// Base query with automatic logout on 401 (except for login request)
const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  const requestUrl = typeof args === 'object' && args?.url ? args.url : '';
  const isLoginRequest = requestUrl.includes('auth/login');

  // On 401: don't logout/redirect for login endpoint — let the login page show invalid credentials
  if (result.error && result.error.status === 401 && !isLoginRequest) {
    localStorage.removeItem(AUTH_TOKEN);
    store.dispatch(signOutSuccess());
    notification.error({
      message: 'Session Expired',
      description: 'Your session has expired. Please login again.',
      duration: 4,
    });
    window.location.href = `${AUTH_PREFIX_PATH}/login`;
  }

  return result;
};

export const api = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'User',
    'Auth',
    'StoryStyle',
    'Story',
    'Tagline',
    'NotificationType',
    'Trendy',
    'Plan',
    'ModelCredit',
    'CreditAmount',
    'CommunityImage',
    'FailedImageImport',
    'Prompt',
    'ArchitectImage',
    'Sfx',
    'Music',
    'Video',
    'PopularStyle',
    'LipSyncStyle',
    'MusicStyle',
    'RecastCharacter',
    'RecastBackground',
    'FalModel',
    'Mood',
    'DefaultSketchImage',
    'DefaultWalkthroughModel',
    'ArchitectInstructionTemplate',
    'ArchitectStyle',
    'AdminDashboard',
    'AdminAnalytics',
  ],
  endpoints: (builder) => ({}),
});

